class VoucherUnsubscribeController extends AbstractController
	@register()
	@inject '$stateParams',
		'PublicRepository'

	initialize: ->
		@giftcardId = @$stateParams.id
		@token = @$stateParams.token
		@isLoading = false
		@isSuccess = false

	unsubscribe: ->
		@isLoading = true

		@PublicRepository
			.unsubscribeGiftcard(@giftcardId, @token)
			.then =>
				@isSuccess = true
			.finally =>
				@isLoading = false
